import React from 'react';
import styled from '@emotion/styled';
import businessImg from 'assets/images/business-group.png';
import dashboardImg from 'assets/images/dashboard.png';
import PageHero from 'components/PageHero';
import PricingCard from 'components/PricingCard';
import { H2, P } from 'components/typography';
import config from 'config';
import Image from 'next/image';

const pricingInfo = {
  title: 'Företag',
  description: [
    'Företagsadministration',
    'Länkar',
    'Sociala medier ',
    'Delningar',
    'QR-kod',
    'Lokalisering',
    'Analytics',
    'Anpassade färger'
  ],
  buttonText: 'Kontakta oss',
  action: { type: 'email', value: config.EMAIL }
};

const Section = styled.div`
  max-width: ${({ theme }) => theme.width.medium};
  margin: auto;
  padding: 10px;
`;

const StyledP = styled(P)`
  font-weight: bold;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 1px;
`;

const Li = styled.li`
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
`;

const StyledPricingCard = styled(PricingCard)`
  margin: auto;

  margin-bottom: 50px;
  max-width: 300px;
  background: ${({ theme }) => theme.palette.GREEN};

  & h3 {
    margin-top: 35px;
    color: ${({ theme }) => theme.palette.BEIGE};
  }
`;

const Row = styled.div`
  display: flex;
  margin: 50px auto;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakPoints.mobile}) {
    flex-direction: ${({ reverse }) => (reverse ? 'column-reverse' : 'column')};
  }
`;

const ImgWrapperDashboard = styled.div`
  flex: 0 0 auto;
  border-radius: 6px;

  width: 300px;
  margin: 0 40px;
`;

const ImgWrapper = styled.div`
  flex: 0 0 auto;
  height: 350px;
  width: 300px;
  margin: 0 40px;
`;

const StyledH2 = styled(H2)`
  margin: 100px 0 30px;
  text-align: center;
`;

const Foretag = () => (
  <>
    <PageHero title="Företag" text="Ta ett steg närmare framtiden" />
    <Section>
      <Row>
        <div>
          <H2>Enkel Adminportal</H2>
          <StyledP>
            Spara värdefull tid, inga onödiga timmar för att beställa och
            administrera pappers visitkort. Ni får ett företagsspecifikt
            gränssnitt för ett samlat utseende för alla anställda. DIGITO
            underlättar hantering samt skapandet av era digitala visitkort.
          </StyledP>
        </div>
        <ImgWrapperDashboard>
          <Image
            src={dashboardImg}
            alt="business-img"
            layout="responsive"
            placeholder="blur"
          />
        </ImgWrapperDashboard>
      </Row>
      <Row reverse>
        <ImgWrapper>
          <Image
            src={businessImg}
            alt="business-img"
            layout="responsive"
            placeholder="blur"
          />
        </ImgWrapper>
        <div>
          <H2>Det skall vara enkelt</H2>
          <StyledP>
            Vi tycker att det skall vara enkelt och smidigt att dela
            kontaktuppgifter. Exempel hur våra kunder använder DIGITO:
          </StyledP>
          <ul>
            <Li>Digitalt visitkort</Li>
            <Li>Mailsignatur</Li>
            <Li>Sociala medier</Li>
            <Li>Digitala möten</Li>
          </ul>
        </div>
      </Row>
      <StyledH2>Prata med oss för en skräddarsydd företagsplan</StyledH2>
      <StyledPricingCard
        key={pricingInfo.title}
        item={pricingInfo}
        buttonColor="primary"
      />
    </Section>
  </>
);

Foretag.layoutOptions = {
  backgroundColor: '#e9d3b8',
  footer: true,
  noBottomSpacing: true
};

export default Foretag;
